module.exports = __webpack_public_path__ + "img/Pulse.d8c4d695.gif";